import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { Client } from '@/api/profile';

@Component({
})
export default class ClientListAbstract extends Vue {
    @Prop({ default: () => [] }) clients!: Client[]
    @Prop({ default: true }) loading!: Boolean
    noResultsText = 'Нет результатов, удовлетворяющих параметрам поиска.'
    get noDataText() {
        return this.loading ? 'Идет поиск...' : this.noResultsText
    }
}